import React from 'react';

interface ValidationMessageProps {
    message?: string;
    id?: string;
    'data-testid'?: string;
}

export const ValidationMessage: React.FC<ValidationMessageProps> = ({ message, id, 'data-testid': dataTestId }) => {
    if (!message) return null;
    return (
        <p id={id} data-testid={dataTestId} role="alert" className="mt-xs text-xs text-error">
            {message}
        </p>
    );
};
